var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "avue-contail yd-layout" },
    [
      _c(
        "div",
        { staticClass: "avue-header yd-top-header" },
        [_c("top"), _c("tags")],
        1
      ),
      _c(
        "div",
        { staticClass: "avue-layout" },
        [
          _c("DrawMeu"),
          _c("div", {}, [
            _c(
              "div",
              { staticClass: "layout-scroll" },
              [
                _vm.hasAuth
                  ? [
                      _c(
                        "keep-alive",
                        [
                          _vm.$route.meta.keepAlive
                            ? _c("router-view", { key: _vm.$route.path })
                            : _vm._e(),
                        ],
                        1
                      ),
                      !_vm.$route.meta.keepAlive
                        ? _c("router-view", {
                            key: _vm.$route.path,
                            staticClass: "avue-view",
                          })
                        : _vm._e(),
                    ]
                  : _c("div", { staticClass: "flex-center flex-col full" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            color: "#434e59",
                            "font-size": "72px",
                            "font-weight": "600",
                          },
                        },
                        [_vm._v("401")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "margin-top-40",
                          staticStyle: {
                            color: "#434e59",
                            "font-size": "24px",
                            "font-weight": "600",
                          },
                        },
                        [
                          _vm._v(
                            "您暂无" +
                              _vm._s(_vm.$route.name) +
                              "权限哦~ 再看就把你吃掉！\n          "
                          ),
                        ]
                      ),
                    ]),
                _c("draggable-icon"),
              ],
              2
            ),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "avue-shade", on: { click: _vm.showCollapse } }),
      _c("search-article"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }